module.exports = __webpack_public_path__ + "static/media/dash.efcdba09.svg";